import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-h-primary-50 py-10" }
const _hoisted_2 = { class: "container mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_General = _resolveComponent("General")!
  const _component_Objects = _resolveComponent("Objects")!
  const _component_Questions = _resolveComponent("Questions")!
  const _component_Feedbacks = _resolveComponent("Feedbacks")!
  const _component_DraftsFeedbacks = _resolveComponent("DraftsFeedbacks")!
  const _component_GridLayout = _resolveComponent("GridLayout")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_GridLayout, {
        list: _ctx.list,
        banner: _ctx.banner,
        onOnScroll: _ctx.scrollMeTo
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", {
            ref: _ctx.enumLinks.general
          }, [
            _createVNode(_component_General, { onOnGetCurrentObjective: _ctx.getCurrentObjective }, null, 8, ["onOnGetCurrentObjective"])
          ], 512),
          _createElementVNode("div", {
            ref: _ctx.enumLinks.questions
          }, [
            _createVNode(_component_Objects)
          ], 512),
          _createElementVNode("div", {
            ref: _ctx.enumLinks.questions
          }, [
            _createVNode(_component_Questions)
          ], 512),
          _createElementVNode("div", {
            ref: _ctx.enumLinks.feedbacks
          }, [
            _createVNode(_component_Feedbacks)
          ], 512),
          _createElementVNode("div", {
            ref: _ctx.enumLinks.draftsFeedbacks
          }, [
            _createVNode(_component_DraftsFeedbacks, { currentObjective: _ctx.currentObjective }, null, 8, ["currentObjective"])
          ], 512)
        ]),
        _: 1
      }, 8, ["list", "banner", "onOnScroll"])
    ])
  ]))
}